import { Box, Modal, type ModalProps } from "@mui/material";
import type React from "react";

type Props = {
	isOpen: boolean;
	onClose?: ModalProps["onClose"];
	children: React.ReactNode;
};

const ModalBase: React.FC<Props> = ({ isOpen, onClose, children }) => {
	return (
		<Modal
			open={isOpen}
			onClose={onClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box className="h-dvh flex flex-col justify-center items-center p-8">
				<Box className="relative w-full max-w-[310px] bg-white rounded-2xl p-4">
					{children}
				</Box>
			</Box>
		</Modal>
	);
};

export default ModalBase;
